import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const createQuestionOperation = async (
  pollId: number,
  questionText: string,
  questionType: string,
  options:
    | { optionText: string; optionValue: number; optionOrder: number }[]
    | undefined,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (questionText.length < 2) {
      toast.warn('על טקסט השאלה להכיל לפחות 2 תווים');
      return;
    }
    setLoading(true);
    const res = await appApi.createPollQuestion(
      pollId,
      questionText,
      questionType,
      options,
    );
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      closeDialog();
    } else {
      await globalSettingsStores.fetchSetting();
      toast.success('השאלה נוספה בהצלחה');
      setLoading(false);
      closeDialog();
    }
  } catch (e) {
    toast.error('לא ניתן לבצע את הפעולה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
